import React, { useState } from 'react';
import api from '../Axios.js'
import { FaTrash } from 'react-icons/fa';

const ChatBot = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { type: 'bot', text: 'Hi! How can I help you today?' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const toggleChat = () => setOpen(!open);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { type: 'user', text: input };
    setMessages(prev => [...prev, userMessage]);
    setLoading(true);

    try {
      const res = await api.post('/ai/ask', {
        query: input
      });

      const botMessage = {
        type: 'bot',
        text: res.data.data || 'No response'
      };

      setMessages(prev => [...prev, botMessage]);
    } catch (err) {
      setMessages(prev => [...prev, { type: 'bot', text: 'Error: ' + err.message }]);
    }

    setInput('');
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') sendMessage();
  };

  return (
    <>
      {/* Floating Button */}
      <button onClick={toggleChat} style={styles.floatingButton}>
        {open ? '×' : '💬'}
      </button>

      {/* Chat Window */}
      {open && (
        <div style={styles.chatWindow}>
          <div style={styles.header}>
            <strong>Kasturi-AI 1.0</strong>
            <div style={styles.iconGroup}>
              <span
                onClick={() => setMessages([])}
                style={styles.iconBtn}
                title="Clear Chat"
              >
                <FaTrash />
              </span>
              <span
                onClick={toggleChat}
                style={styles.iconBtn}
                title="Close"
              >
                X
              </span>
            </div>
          </div>

          <div style={styles.chatBox}>
            {messages.map((msg, idx) => (
              <div
                key={idx}
                style={{
                  ...styles.message,
                  alignSelf: msg.type === 'user' ? 'flex-end' : 'flex-start',
                  backgroundColor: msg.type === 'user' ? '#d9dcd9' : '#d9dcd9'
                }}
              >
                {msg.text}
              </div>
            ))}
            {loading && <div style={styles.loading}>
              <img
              src={
                "/public/images/colorful_loader.gif"
              }
              alt="loading..."
              style={{"height":"50px"}}
            />
            </div>}
          </div>

          <div style={styles.inputBox}>
            <input
              type="text"
              value={input}
              placeholder="Ask something..."
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              style={styles.input}
            />
            <button onClick={sendMessage} style={styles.sendBtn}>➤</button>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  floatingButton: {
    position: 'fixed',
    bottom: 20,
    right: 20,
    zIndex: 1101,
    borderRadius: '50%',
    width: 60,
    height: 60,
    fontSize: 24,
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    boxShadow: '0 0 10px rgba(0,0,0,0.2)',
    cursor: 'pointer',
  },
  chatWindow: {
    position: 'fixed',
    bottom: 90,
    right: 20,
    width: 320,
    maxHeight: 550,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: '0 0 20px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    zIndex: 1101,
  },

  header: {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '10px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  iconGroup: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },

  iconBtn: {
    cursor: 'pointer',
    fontSize: '18px',
    color: '#fff',
  },

  closeBtn: {
    cursor: 'pointer',
    fontSize: 18,
  },
  chatBox: {
    padding: 10,
    flex: 1,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    backgroundColor: '#f5f5f5',
  },
  message: {
    padding: 8,
    borderRadius: 10,
    maxWidth: '75%',
  },
  inputBox: {
    display: 'flex',
    borderTop: '1px solid #ccc',
    padding: 8,
    backgroundColor: '#fff',
  },
  input: {
    flex: 1,
    border: '1px solid #ccc',
    borderRadius: 5,
    padding: 8,
  },
  sendBtn: {
    marginLeft: 8,
    padding: '0 12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: 5,
    cursor: 'pointer',
  },
  loading: {
    fontStyle: 'italic',
    color: '#888',
  },
};

export default ChatBot;
